export function xdate() {
  xdate.prototype.topChar = { "+": "⁺", "-": "⁻", "(": "⁽", ")": "⁾" };
  xdate.prototype.topNum = ["º", "¹", "²", "³", "⁴", "⁵", "⁶", "⁷", "⁸", "⁹"];
  xdate.prototype.weekList = ["日", "一", "二", "三", "四", "五", "六"];
}
//填充从开始到结束，以每一天为一个元素填充数组
xdate.prototype.fillRange = function (start, end, maxCount = 31) {
  let dayMap = [];
  if (!this.valid(start) || !this.valid(end)) {
    return dayMap;
  }
  //处理日期分布
  let current = this.toDay(start);
  while (current <= this.toDay(end) && dayMap.length <= maxCount) {
    dayMap.push(new Date(this.format(current, "yyyy/MM/dd")));
    current = this.addDay(current, 1);
  }
  return dayMap;
};
//将日期数组，转换为指定格式的数组
xdate.prototype.formatRange = function (
  dateRange,
  fmt = "dd日",
  fillPlus = true
) {
  if (!(dateRange instanceof Array) || dateRange.length == 0) {
    return [];
  }
  let fms = [];
  let min = dateRange[0];
  dateRange.forEach((v) => {
    let currentFmt = fmt;
    if (fillPlus) {
      let dm = this.diffMonth(min, v);
      if (dm > 0) {
        currentFmt += this.topChar["+"] + this.topNum[dm];
      }
    }
    fms.push({ fmt: this.format(v, currentFmt), value: v });
  });
  return fms;
};
xdate.prototype.getOffset=function(dateRange, current) {
  let offset = -1
  if (
      dateRange.length == 0 ||
      !this.valid(current)
  ) {
      return offset;
  }

  dateRange.forEach((v, i) => {
      if (this.diffDay(this.toDay(v), this.toDay(current)) == 0) {
          offset = i;
      }
  });
  return offset;
}

xdate.prototype.valid = function (value) {
  return typeof value == "object" && value instanceof Date;
};

xdate.prototype.now = function () {
  return new Date();
};
xdate.prototype.string = function (date) {
  return this.format(date, "yyyy-MM-dd MM:mm:ss");
};
xdate.prototype.addDay = function (date, day) {
  let d = day || 0;
  let ndate = new Date(date);
  ndate.setDate(date.getDate() + d);
  return ndate;
};

xdate.prototype.diff = function (s, e) {
  return Math.abs(e - s);
};
xdate.prototype.diffSecond = function (s, e) {
  return this.diff(s, e) / 1000;
};
xdate.prototype.diffMinute = function (s, e) {
  return this.diff(s, e) / 1000 / 60;
};
xdate.prototype.diffHour = function (s, e) {
  return this.diff(s, e) / 1000 / 60 / 60;
};
xdate.prototype.diffDay = function (s, e) {
  return Math.floor(this.diff(s, e) / 1000 / 60 / 60 / 24);
};
xdate.prototype.diffMonth = function (s, e) {
  let months1 = e.getFullYear() * 12 + e.getMonth();
  let months2 = s.getFullYear() * 12 + s.getMonth();
  return Math.abs(months1 - months2);
};

xdate.prototype.getWeek = function (date) {
  let index = new Date(date).getDay();
  return this.weekList[index];
};
xdate.prototype.min = function (start, end) {
  if (!this.valid(start)) {
    return;
  }
  if (!this.valid(end)) {
    return start;
  }
  return start < end ? start : end;
};
xdate.prototype.max = function (start, end) {
  if (!this.valid(start)) {
    return;
  }
  if (!this.valid(end)) {
    return start;
  }
  return start > end ? start : end;
};
xdate.prototype.toDay = function (date) {
  if (!this.valid(date)) {
    return;
  }
  let year = date.getFullYear();
  let month = date.getMonth();
  let day = date.getDate();
  return new Date(year, month, day);
};

xdate.prototype.getUnix = function () {
  var myDate = new Date("1970/01/01 0:0:0");
  return myDate.getTime();
};

//日期格式转换
xdate.prototype.format = function (date, fmt = "yyyy-MM-dd HH:mm") {
  if (!date || date.toString() == "Invalid Date") {
    return "";
  }
  if (fmt == "shortDatetime" || fmt == "sdt") {
    fmt = "MM-dd HH:mm:ss";
  }
  let d = new Date(Date.parse(date));
  var o = {
    "W+": xdate.prototype.weekList[d.getDay()], // 周
    "M+": d.getMonth() + 1, // 月份
    "d+": d.getDate(), // 日
    "h+": d.getHours() % 12 == 0 ? 12 : d.getHours() % 12, //12小时制
    "H+": d.getHours(), //24小时小时
    "m+": d.getMinutes(), // 分
    "s+": d.getSeconds(), // 秒
    "q+": Math.floor((d.getMonth() + 3) / 3), // 季度
    S: d.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (d.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};
xdate.prototype.debug = function () {
  // console.log("add.day:",this.format(this.addDay(new Date(),-7)))
  // let ranges = this.fillRange(
  //   this.addDay(new Date(), -7),
  //   this.addDay(new Date(), 20)
  // );
  // console.log("fill.range:", ranges);
  // console.log("formats:", this.formatRange(ranges, "yyyy-MM-dd"));
  // console.log("getRangeIdx:",ranges,this.getRangeIdx(ranges,this.addDay(new Date(),1),this.addDay(new Date(),3)))
};
